








































































import { Component, Mixins, Watch } from "vue-property-decorator";

import Comments from '@share/comments/components/Comments.vue';

import S1Information from "@share/committees/committee/sections/s-1-information/S1Information.vue";
import S2Tickets from "@share/committees/committee/sections/s-2-tickets/S2Tickets.vue";
import S3Result from "@share/committees/committee/sections/s-3-result/S3Result.vue";

import ObjectLayout from "@service/layouts/ObjectViewLayout.vue";
import ObjectSidebar from "@share/object-sidebar/ObjectSidebar.vue";
import CommitteeLayout from "@share/committees/committee/components/CommitteeLayout.vue";
import SegmentControl from  "@share/common/segment/Segment.vue";

import { CommitteeViewService } from "@share/committees/committee/services/CommitteeViewService"
import { repositories } from "@service/api/Repositories";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { UserProfileService } from "@share/common/services/dataLoading/userProfiles/UserProfilesService";
import { CommitteeViewModelInterface } from "@share/committees/committee/types/CommitteeViewModel";
import { CommitteeModelMapper } from "../committee-form/helpers/CommitteeModelMapper";
import { CommitteeModelExtended } from "@api/models/committees/CommitteeModel";
import { getIsCommitteeAllowed } from "@share/common/helpers/ticketSystemHelpers";

import UserProfileCollector from "@share/committees/common/service-components/UserProfilesCollector.vue";
import Loadable from "@share/common/service-components/loadable/Loadable.vue";
import E404 from "@service/views/errors/e404.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";

import { TicketRowInterfaceView } from "@share/committees/common/types/interfaces/TicketsRowInterface";
import { TableRowModelView } from "@share/committees/common/types/models/TicketsTableRowModel";
import { RootState } from "@service/store/types/RootState";

enum Section {
    information = 1,
    tickets,
    result
}

@Component({
    components: { ObjectLayout, ObjectSidebar, CommitteeLayout, S1Information, S2Tickets, S3Result, Comments, SegmentControl, E404, BounceSpinner }
})

export default class Committee extends Mixins(UserProfileCollector, Loadable) {

    public readonly COMMITTEES_SCHEMA_ID = "Committees";

    hideSidebar = false;
    committee: CommitteeViewModelInterface | null = null;

    activeSection: Section = Section.information;
    Section = Section;

    endCommitteeDisabled = false;

    ticketsList: TicketRowInterfaceView[] = [];

    /**
     * service for network communication
     */
    viewService = new CommitteeViewService(
        repositories.get(RepositoryFabric.OBJECT)
    );

    created() {

        this.userProfileService = new UserProfileService(
            this.$repositories.get(RepositoryFabric.USER),
            ["id", "userId", "lastName", "firstName", "photoFileId", "direction", "position"]
        );

        this.getCommittee();
    }

    get selectedTimeZoneOffset() {
        return (this.$store.state as RootState).selectedTimeZoneOffset;
    }

    async getCommittee() {

        try {
            this.isLoading = true;
            const committee = new CommitteeModelExtended((await this.viewService.getCommittee(this.committeeId))[0]);
            const profiles = await this.userProfileService.getUserProfiles([...committee.userIds, committee.secretary]);

            this.committee = CommitteeModelMapper.toView(committee, profiles, this.selectedTimeZoneOffset, this.lang);
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
        }
        finally {
            this.isLoading = false;
        }
    }

    async endCommittee() {
        try {
            this.endCommitteeDisabled = true;
            await (this.committee?.id && this.viewService.endTicket(this.committee.id));
            await this.getCommittee();
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
        }
        finally {
            this.endCommitteeDisabled = false;
        }
    }

    async updateTicketsList() {
        if(!this.committee) {return;}
        try {
            this.isLoading = true;

            const rawList = (await this.viewService.getTickets(this.committee.ticketIds, this.committee.subjectType));

            // LIST:
            let list = rawList.map(item => new TableRowModelView(item))

            const userIds = rawList.map(item => [...item.ownerIds]).flat().filter((x: number) => x);

            this.updateUsersProfilesList(userIds);
            this.ticketsList = list;
        }
        catch(e) {
            this.$store.dispatch("reportError", e);
        }
        finally {
            this.isLoading = false;
        }
    }

    @Watch('committee')
    watchCommittee(committee: CommitteeViewModelInterface | null) {
        if(committee) {
            this.$store.dispatch("setPageTitle", `${this.$t("common.committees")} - ${committee.title}` )
        }
    }

    @Watch('activeSection')
    watchActiveSection(section: Section) {
        if(section === Section.tickets || section === Section.result) {
            this.updateTicketsList()
        }
    }

    openTicket(ticket: TicketRowInterfaceView) {
        this.$emit('openTicket', ticket, this.committee?.subjectType);
    }

    editTicket(ticket: TicketRowInterfaceView) {
        this.$emit('editTicket', ticket, this.committee?.subjectType);
    }

    get committeeId() {
        return this.$route.params.id
    }

    changeSection(section: Section) {
        this.activeSection = section;
    }

    close() {
        this.$emit('close')
    }

    onNewComment() {
        //
    }

    selectProfile() {
        //
    }

    onSidebarVisibilityChange() {
        //
    }

    get membersUserProfiles() {
        return this.committee?.membersUserProfiles || [];
    }

    get segmentData()  {
        return [
            {
                active: this.activeSection === Section.information,
                title: this.$t('program.info'),
                value: Section.information
            },
            {
                active: this.activeSection === Section.tickets,
                title: this.committee?.subjectTypeText || this.$t('common.ticketSystemIdeas').toString(),
                value: Section.tickets
            },
            {
                active: this.activeSection === Section.result,
                title: this.$t('committees.view.result'),
                value: Section.result
            },
        ]
    }

    get lang() {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "en";
    }

    get isAdmin() {
        return this.$store.getters['isAdmin'];
    }

    get isCommitteeAdmin() {
        return getIsCommitteeAllowed(this.$store.getters["groupIds"]) && this.isAdmin;
    }
}

